import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "feelgrid.temperature.icon",
  "use": "feelgrid.temperature.icon-usage",
  "viewBox": "0 0 15.987 45.857",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.987 45.857\" id=\"feelgrid.temperature.icon\"><defs><style>#feelgrid.temperature.icon .cls-1{fill:#ff7285}</style></defs><path id=\"feelgrid.temperature.icon_Path_1005\" data-name=\"Path 1005\" class=\"cls-1\" d=\"M91.083,99.095V86.789H87.718V99.095a5.364,5.364,0,1,0,3.366,0Z\" transform=\"translate(-81.512 -66.28)\" /><path id=\"feelgrid.temperature.icon_Path_1006\" data-name=\"Path 1006\" class=\"cls-1\" d=\"M91.939,82.141V55.321a4.312,4.312,0,0,0-8.624,0v26.82A7.994,7.994,0,1,0,95.62,88.872,8.43,8.43,0,0,0,91.939,82.141ZM87.521,95.709a7,7,0,0,1-6.942-6.942,6.833,6.833,0,0,1,3.155-5.785l.526-.316V55.321a3.26,3.26,0,0,1,6.521,0V59h-2.84V60.37h2.84v4.523h-2.84V66.26h2.84V82.667l.526.316a6.92,6.92,0,0,1-3.786,12.726Z\" transform=\"translate(-79.633 -51.009)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/feelgrid.temperature.icon.svg
// module id = TiAg
// module chunks = 13